export default "__VITE_ASSET__Cbl9EDeQ__"